// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables */
:root {
  /* Primary Colors */
  --primary-color: #3498db;
  --primary-dark: #2980b9;
  --primary-light: #5dade2;

  /* Secondary Colors */
  --secondary-color: #2ecc71;
  --secondary-dark: #27ae60;
  --secondary-light: #58d68d;

  /* Danger Colors */
  --danger-color: #e74c3c;
  --danger-dark: #c0392b;
  --danger-light: #ec7063;

  /* Metallic Position Colors */
  --gold-light: #FFD700;
  --gold-dark: #DAA520;
  --silver-light: #C0C0C0;
  --silver-dark: #A8A8A8;
  --bronze-light: #CD7F32;
  --bronze-dark: #B87333;

  /* Neutral Colors */
  --background-color: #f8f9fa;
  --surface-color: #ffffff;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
  --text-muted: #95a5a6;
  --border-color: #e1e8ed;
  --border-dark: #bdc3c7;

  /* Navigation */
  --nav-bg: #2c3e50;
  --nav-text: #ecf0f1;
  --nav-hover: #34495e;
  --nav-active: #3498db;

  /* Shadows */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.15);
}

/* Base Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  margin: 0;
  background-color: var(--background-color);
  color: var(--text-primary);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  margin: 0 0 1rem 0;
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-primary);
}

h1 {
  font-size: 2.5rem;
  font-weight: 800;
}

h2 {
  font-size: 2rem;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

p {
  margin: 0 0 1rem 0;
  color: var(--text-secondary);
}

label {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.9rem;
}

/* Header & Navigation */
header {
  background: var(--nav-bg);
  box-shadow: var(--shadow-md);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  gap: 3rem;
}

nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex: 1 1;
  flex-wrap: wrap;
}

nav a {
  color: var(--nav-text);
  text-decoration: none;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  border-radius: 8px;
  margin: 0.5rem 0;
  min-height: 44px;
}

nav ul li:not(.settings-icon) a {
  position: relative;
  top: 3px;
}

nav a:hover {
  background: var(--nav-hover);
  color: #ffffff;
}

nav a.active {
  background: var(--nav-active);
  color: #ffffff;
}

.settings-icon a {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  padding: 0.75rem 1rem;
}

.pause-icon button {
  background: transparent;
  box-shadow: none;
  font-size: 1.25rem;
  padding: 0.75rem 1rem;
}

.live-nav-controls {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-dark) 100%);
  border-radius: 8px;
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
  padding: 0.5rem;
}

.live-nav-controls button {
  background: transparent;
  box-shadow: none;
  color: white;
  padding: 0.75rem 1rem;
}

.live-nav-controls button.play-button-active {
  background: linear-gradient(135deg, var(--danger-color) 0%, var(--danger-dark) 100%);
}

/* Logo */
.floating-logo {
  height: 35px;
  filter: brightness(0) invert(1);
  transition: transform 0.2s ease;
  position: relative;
  top: -6px;
}

.floating-logo:hover {
  transform: scale(1.05);
}

/* Layout */
main {
  padding: 3rem 0;
  min-height: calc(100vh - 200px);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Card Component */
.card {
  background: var(--surface-color);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: var(--shadow-lg);
}

.card-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid var(--border-color);
}

.card-header h2 {
  margin: 0;
}

/* Badges */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 0.875rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.badge-primary {
  background: rgba(52, 152, 219, 0.1);
  color: var(--primary-color);
}

.badge-success {
  background: rgba(46, 204, 113, 0.1);
  color: var(--secondary-color);
}

.badge-danger {
  background: rgba(231, 76, 60, 0.1);
  color: var(--danger-color);
}

.badge-warning {
  background: rgba(243, 156, 18, 0.1);
  color: #f39c12;
}

.badge-info {
  background: rgba(52, 152, 219, 0.1);
  color: #3498db;
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);
}

.empty-state-icon {
  font-size: 4rem;
  color: var(--text-muted);
  margin-bottom: 1rem;
}

.empty-state-text {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}

.empty-state-description {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
}

/* Loading Spinner */
.loading-spinner {
  border: 3px solid rgba(52, 152, 219, 0.2);
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Dialog Styles */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.dialog {
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: var(--shadow-xl);
  width: 90%;
  max-width: 500px;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dialog h3 {
  margin-top: 0;
  color: var(--text-primary);
  font-size: 1.5rem;
}

.dialog p {
  color: var(--text-secondary);
}

.dialog ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.dialog li {
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}

.dialog .dialog-actions {
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.generate-fixtures-btn {
  margin-left: 1rem;
  margin-top: 1rem;
}

/* Select Container */
.select-container {
  position: relative;
  display: inline-block;
  min-width: 200px;
}

.select-container select {
  appearance: none;
  padding-right: 2.5rem;
  cursor: pointer;
  width: 100%;
}

.select-container::after {
  content: '▼';
  font-size: 0.7rem;
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--text-secondary);
  transition: color 0.2s ease;
}

.select-container:hover::after {
  color: var(--text-primary);
}

/* Forms */
form {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  align-items: flex-end;
  flex-wrap: wrap;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
  flex: 1 1;
}

.form-group label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
}

/* Input Fields */
input[type="text"],
input[type="number"],
select,
textarea {
  padding: 0.875rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  transition: all 0.2s ease;
  background: var(--surface-color);
  color: var(--text-primary);
}

input[type="text"]:focus,
input[type="number"]:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

input[type="text"]::placeholder,
input[type="number"]::placeholder,
textarea::placeholder {
  color: var(--text-muted);
}

input.form-input-reduced {
  width: 14rem;
  flex-grow: 0;
}

/* Buttons */
button,
.btn {
  padding: 0.875rem 1.75rem;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
  letter-spacing: 0.3px;
}

button:hover,
.btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

button:active,
.btn:active {
  transform: translateY(0);
}

button[type="submit"],
button.submit,
.btn-success {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-dark) 100%);
}

button.danger,
.btn-danger {
  background: linear-gradient(135deg, var(--danger-color) 0%, var(--danger-dark) 100%);
}

button.icon-btn,
.btn-icon {
  padding: 0.625rem;
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

button.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

button.btn-lg {
  padding: 1rem 2rem;
  font-size: 1.125rem;
}

/* Tables */
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

th, td {
  padding: 1.25rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
}

th {
  background: linear-gradient(135deg, var(--nav-bg) 0%, #34495e 100%);
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

tbody tr {
  background: var(--surface-color);
  transition: all 0.2s ease;
}

tbody tr:hover {
  background: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

tbody tr:last-child td {
  border-bottom: none;
}

.table-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* Mobile Table Utilities */
.mobile-hide {
  display: table-cell;
}

.mobile-show {
  display: none;
}

.mobile-stack {
  display: block;
}

/* Live Page Layout */
.live-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
}

.live-container.live-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.live-league {
  flex: 1 1;
}

/* Settings Button Group */
.settings-button-group {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.settings-buttons {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* League Display Styles */
.next-up-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 4px solid var(--primary-color);
}

.next-up-text {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}

.progress-bar-container {
  height: 6px;
  width: 100%;
  background-color: #dee2e6;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.1s linear;
  border-radius: 3px;
}

.league-header {
  margin-bottom: 1rem;
}

/* Standings Table Styles */
.standings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
}

.standings-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.5rem;
  font-weight: 700;
}

.league-name-badge {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
  letter-spacing: 0.3px;
}

.standings-table-container {
  background: var(--surface-color);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  overflow-y: hidden;
  margin: 1rem 0;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

/* Subtle background tint using league color - uses Color tool */
.standings-table-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--league-color-light, hsl(145, 63%, 95%));
  opacity: 0.3;
  pointer-events: none;
  border-radius: 12px;
}

.standings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  position: relative;
  z-index: 1;
}

.standings-table thead {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: rgb(60, 62, 85);
}

.standings-table th {
  padding: 1rem 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  border: none;
  position: relative;
  cursor: help;
  transition: background-color 0.2s ease;
}

.standings-table th:hover {
  background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);
}

/* Custom Tooltip Styles */
.standings-table th[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.3px;
  text-transform: none;
}

.standings-table th[title]:hover::before {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid rgba(0, 0, 0, 0.9);
  z-index: 1001;
}

.position-header {
  width: 50px;
  text-align: center;
}

.team-header {
  text-align: left;
  min-width: 180px;
}

.stat-header {
  width: 60px;
  text-align: center;
}

.points-header {
  width: 80px;
  text-align: center;
}

.standings-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.standings-row:nth-child(even) {
  background-color: #fafbfc;
}

.standings-row:hover {
  background-color: #e8f4fd;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.standings-row {
  border-left: 4px solid var(--league-color-dark, #2ecc71);
}

.standings-table td {
  padding: 1rem 0.75rem;
  border: none;
  vertical-align: middle;
}

.position-cell {
  text-align: center;
  font-weight: 600;
}

.position-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 0.9rem;
  background: linear-gradient(135deg, #ecf0f1 0%, #bdc3c7 100%);
  color: #2c3e50;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.position-number.first-place {
  background: linear-gradient(135deg, var(--gold-light) 0%, var(--gold-dark) 100%);
  color: #2c3e50;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4);
}

.position-number.second-place {
  background: linear-gradient(135deg, var(--silver-light) 0%, var(--silver-dark) 100%);
  color: #2c3e50;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(192, 192, 192, 0.4);
}

.position-number.third-place {
  background: linear-gradient(135deg, var(--bronze-light) 0%, var(--bronze-dark) 100%);
  color: white;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(205, 127, 50, 0.4);
}

.team-cell {
  text-align: left;
}

.team-name {
  font-weight: 600;
  font-size: 1rem;
  color: #2c3e50;
}

.stat-cell {
  text-align: center;
  font-weight: 500;
  color: #555;
}

.stat-cell.wins {
  color: #27ae60;
  font-weight: 600;
}

.stat-cell.draws {
  color: #f39c12;
  font-weight: 600;
}

.stat-cell.losses {
  color: #e74c3c;
  font-weight: 600;
}

.goal-difference.positive {
  color: #27ae60;
  font-weight: 600;
}

.goal-difference.negative {
  color: #e74c3c;
  font-weight: 600;
}

.goal-difference.neutral {
  color: #7f8c8d;
}

.points-cell {
  text-align: center;
}

.points-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 32px;
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  border-radius: 16px;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0 8px;
  box-shadow: 0 2px 4px rgba(52, 152, 219, 0.3);
}

/* Settings Icon */
.pause-icon,
.settings-icon {
  margin-left: 0;
}

.settings-icon {
  margin-left: auto;
}

/* League Row Styling */
.league-row {
  transition: all 0.2s ease;
}

.league-row:hover {
  background-color: #e8f4fd;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Navigation */
  nav {
    padding: 0.5rem 1rem;
    gap: 1rem;
    flex-wrap: wrap;
  }

  nav ul {
    gap: 0.5rem;
    justify-content: center;
  }

  nav a {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    min-height: 44px;
    min-width: 44px;
  }

  .floating-logo {
    height: 32px;
    margin-bottom: 0.25rem;
  }

  .settings-icon a {
    padding: 0.75rem;
  }

  /* Layout */
  main {
    padding: 2rem 0;
  }

  .container {
    padding: 0 1rem;
  }

  .card {
    padding: 1.5rem;
    border-radius: 12px;
  }

  /* Typography */
  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  h3 {
    font-size: 1.25rem;
  }

  /* Forms */
  form {
    flex-direction: column;
    align-items: stretch;
  }

  .form-group {
    min-width: 100%;
  }

  /* Buttons */
  button,
  .btn {
    padding: 0.75rem 1.25rem;
    font-size: 0.9rem;
  }

  /* Tables */
  table {
    font-size: 0.9rem;
  }

  th,
  td {
    padding: 1rem 0.75rem;
  }

  /* Standings Table */
  .standings-table {
    font-size: 0.85rem;
    min-width: 100%;
  }

  .standings-table th,
  .standings-table td {
    padding: 0.75rem 0.5rem;
    white-space: nowrap;
  }

  .team-header {
    min-width: 120px;
  }

  .stat-header {
    width: 45px;
    min-width: 45px;
  }

  .points-header {
    width: 60px;
    min-width: 60px;
  }

  .position-header {
    width: 50px;
    min-width: 50px;
  }

  .position-number {
    width: 24px;
    height: 24px;
    font-size: 0.8rem;
  }

  .points-badge {
    min-width: 32px;
    height: 28px;
    font-size: 0.85rem;
  }

  /* Ensure table scrolls horizontally on mobile */
  .standings-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Dialog */
  .dialog {
    padding: 2rem;
    max-width: 90%;
  }

  /* Mobile Table Utilities */
  .mobile-hide {
    display: none;
  }

  .mobile-show {
    display: table-cell;
  }

  .mobile-stack {
    display: block;
    margin-bottom: 0.5rem;
  }

  /* Fixtures table mobile optimization */
  .fixtures-table td {
    padding: 0.75rem 0.5rem;
  }

  .fixtures-table input[type="number"] {
    width: 40px !important;
    padding: 0.5rem 0.25rem;
    text-align: center;
    font-size: 0.875rem;
  }

  .fixtures-table .table-actions {
    gap: 0.25rem;
  }

  .fixtures-table .table-actions button {
    min-width: 40px;
  }

  /* Results table mobile optimization */
  .results-table td {
    padding: 0.75rem 0.5rem;
  }

  .results-table .table-actions {
    gap: 0.25rem;
  }

  /* Live Page Layout */
  .live-container {
    flex-direction: column;
    padding: 0.5rem;
  }

  .live-container.live-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .live-league {
    width: 100%;
    margin-bottom: 2rem;
  }

  .live-league:last-child {
    margin-bottom: 0;
  }

  /* Next Up Section - Full width on mobile */
  .next-up-section {
    padding: 0.75rem;
  }

  .next-up-text {
    font-size: 0.9rem;
  }

  .progress-bar-container {
    height: 5px;
  }

  /* Settings Button Group */
  .settings-button-group {
    flex-direction: column;
    align-items: stretch;
  }

  .settings-buttons {
    width: 100%;
  }

  .settings-buttons button {
    flex: 1 1;
  }
}

/* Small Mobile - 480px and below */
@media (max-width: 480px) {
  /* Navigation */
  nav {
    padding: 0.5rem;
    gap: 0.5rem;
    flex-direction: column;
    align-items: center;
  }

  nav ul {
    width: 100%;
    justify-content: space-around;
    gap: 0.25rem;
  }

  nav a {
    padding: 0.625rem 0.75rem;
    font-size: 0.8rem;
    min-height: 44px;
    min-width: 44px;
    text-align: center;
  }

  .floating-logo {
    height: 28px;
    margin-bottom: 0.5rem;
  }

  .settings-icon {
    margin-left: 0;
  }

  .settings-icon a {
    padding: 0.625rem;
  }

  /* Layout */
  main {
    padding: 1.5rem 0;
  }

  .container {
    padding: 0 0.75rem;
  }

  .card {
    padding: 1rem;
    border-radius: 8px;
  }

  /* Typography */
  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  h3 {
    font-size: 1.1rem;
  }

  /* Buttons */
  button,
  .btn {
    padding: 0.625rem 1rem;
    font-size: 0.85rem;
  }

  /* Tables */
  table {
    font-size: 0.8rem;
  }

  th,
  td {
    padding: 0.75rem 0.5rem;
  }

  /* Standings Table */
  .standings-table {
    font-size: 0.75rem;
    min-width: 100%;
  }

  .standings-table th,
  .standings-table td {
    padding: 0.625rem 0.375rem;
    white-space: nowrap;
  }

  .team-header {
    min-width: 100px;
  }

  .stat-header {
    width: 40px;
    min-width: 40px;
  }

  .points-header {
    width: 50px;
    min-width: 50px;
  }

  .position-header {
    width: 45px;
    min-width: 45px;
  }

  .position-number {
    width: 22px;
    height: 22px;
    font-size: 0.75rem;
  }

  .points-badge {
    min-width: 28px;
    height: 24px;
    font-size: 0.75rem;
    padding: 0 6px;
  }

  /* Dialog */
  .dialog {
    padding: 1.5rem;
    max-width: 95%;
  }

  /* Fixtures table - more compact */
  .fixtures-table input[type="number"] {
    width: 35px !important;
    padding: 0.375rem 0.125rem;
    font-size: 0.8rem;
  }

  .fixtures-table .table-actions {
    flex-wrap: wrap;
  }

  .fixtures-table .table-actions button {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  /* Results table - more compact */
  .results-table td {
    padding: 0.625rem 0.375rem;
    font-size: 0.85rem;
  }

  .results-table .table-actions button {
    padding: 0.5rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;;EAExB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;;EAE1B,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;;EAEtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;;EAErB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;EAC/E,SAAS;EACT,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0FAA0F;EAC1F,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oFAAoF;AACtF;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;AACX;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;;;EAIE,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;;;EAIE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;EACzB,sFAAsF;EACtF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,0FAA0F;AAC5F;;AAEA;;EAEE,oFAAoF;AACtF;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAAyD;EACzD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gFAAgF;EAChF,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,oFAAoF;EACpF,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oFAAoF;EACpF,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf;IACE,oBAAoB;IACpB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,UAAU;EACV;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA,YAAY;EACZ;;IAEE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA,gDAAgD;EAChD;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,WAAW;EACX;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA,uCAAuC;EACvC;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf;IACE,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,YAAY;EACZ;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,WAAW;EACX;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA,WAAW;EACX;IACE,eAAe;IACf,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n/* CSS Variables */\n:root {\n  /* Primary Colors */\n  --primary-color: #3498db;\n  --primary-dark: #2980b9;\n  --primary-light: #5dade2;\n\n  /* Secondary Colors */\n  --secondary-color: #2ecc71;\n  --secondary-dark: #27ae60;\n  --secondary-light: #58d68d;\n\n  /* Danger Colors */\n  --danger-color: #e74c3c;\n  --danger-dark: #c0392b;\n  --danger-light: #ec7063;\n\n  /* Metallic Position Colors */\n  --gold-light: #FFD700;\n  --gold-dark: #DAA520;\n  --silver-light: #C0C0C0;\n  --silver-dark: #A8A8A8;\n  --bronze-light: #CD7F32;\n  --bronze-dark: #B87333;\n\n  /* Neutral Colors */\n  --background-color: #f8f9fa;\n  --surface-color: #ffffff;\n  --text-primary: #2c3e50;\n  --text-secondary: #7f8c8d;\n  --text-muted: #95a5a6;\n  --border-color: #e1e8ed;\n  --border-dark: #bdc3c7;\n\n  /* Navigation */\n  --nav-bg: #2c3e50;\n  --nav-text: #ecf0f1;\n  --nav-hover: #34495e;\n  --nav-active: #3498db;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Base Styles */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  margin: 0;\n  background-color: var(--background-color);\n  color: var(--text-primary);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  margin: 0 0 1rem 0;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-primary);\n}\n\nh1 {\n  font-size: 2.5rem;\n  font-weight: 800;\n}\n\nh2 {\n  font-size: 2rem;\n  font-weight: 700;\n}\n\nh3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\np {\n  margin: 0 0 1rem 0;\n  color: var(--text-secondary);\n}\n\nlabel {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n/* Header & Navigation */\nheader {\n  background: var(--nav-bg);\n  box-shadow: var(--shadow-md);\n  padding: 0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\nnav {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n}\n\nnav ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\nnav a {\n  color: var(--nav-text);\n  text-decoration: none;\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  font-size: 0.95rem;\n  letter-spacing: 0.3px;\n  border-radius: 8px;\n  margin: 0.5rem 0;\n  min-height: 44px;\n}\n\nnav ul li:not(.settings-icon) a {\n  position: relative;\n  top: 3px;\n}\n\nnav a:hover {\n  background: var(--nav-hover);\n  color: #ffffff;\n}\n\nnav a.active {\n  background: var(--nav-active);\n  color: #ffffff;\n}\n\n.settings-icon a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  padding: 0.75rem 1rem;\n}\n\n.pause-icon button {\n  background: transparent;\n  box-shadow: none;\n  font-size: 1.25rem;\n  padding: 0.75rem 1rem;\n}\n\n.live-nav-controls {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-dark) 100%);\n  border-radius: 8px;\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n  padding: 0.5rem;\n}\n\n.live-nav-controls button {\n  background: transparent;\n  box-shadow: none;\n  color: white;\n  padding: 0.75rem 1rem;\n}\n\n.live-nav-controls button.play-button-active {\n  background: linear-gradient(135deg, var(--danger-color) 0%, var(--danger-dark) 100%);\n}\n\n/* Logo */\n.floating-logo {\n  height: 35px;\n  filter: brightness(0) invert(1);\n  transition: transform 0.2s ease;\n  position: relative;\n  top: -6px;\n}\n\n.floating-logo:hover {\n  transform: scale(1.05);\n}\n\n/* Layout */\nmain {\n  padding: 3rem 0;\n  min-height: calc(100vh - 200px);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* Card Component */\n.card {\n  background: var(--surface-color);\n  padding: 2rem;\n  border-radius: 16px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  transition: box-shadow 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n.card-header {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.card-header h2 {\n  margin: 0;\n}\n\n/* Badges */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.375rem 0.875rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.badge-primary {\n  background: rgba(52, 152, 219, 0.1);\n  color: var(--primary-color);\n}\n\n.badge-success {\n  background: rgba(46, 204, 113, 0.1);\n  color: var(--secondary-color);\n}\n\n.badge-danger {\n  background: rgba(231, 76, 60, 0.1);\n  color: var(--danger-color);\n}\n\n.badge-warning {\n  background: rgba(243, 156, 18, 0.1);\n  color: #f39c12;\n}\n\n.badge-info {\n  background: rgba(52, 152, 219, 0.1);\n  color: #3498db;\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: var(--text-secondary);\n}\n\n.empty-state-icon {\n  font-size: 4rem;\n  color: var(--text-muted);\n  margin-bottom: 1rem;\n}\n\n.empty-state-text {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n}\n\n.empty-state-description {\n  color: var(--text-secondary);\n  margin-bottom: 1.5rem;\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  border: 3px solid rgba(52, 152, 219, 0.2);\n  border-top: 3px solid var(--primary-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: 2rem auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Dialog Styles */\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.dialog {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 16px;\n  box-shadow: var(--shadow-xl);\n  width: 90%;\n  max-width: 500px;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dialog h3 {\n  margin-top: 0;\n  color: var(--text-primary);\n  font-size: 1.5rem;\n}\n\n.dialog p {\n  color: var(--text-secondary);\n}\n\n.dialog ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.dialog li {\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.dialog .dialog-actions {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.generate-fixtures-btn {\n  margin-left: 1rem;\n  margin-top: 1rem;\n}\n\n/* Select Container */\n.select-container {\n  position: relative;\n  display: inline-block;\n  min-width: 200px;\n}\n\n.select-container select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding-right: 2.5rem;\n  cursor: pointer;\n  width: 100%;\n}\n\n.select-container::after {\n  content: '▼';\n  font-size: 0.7rem;\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--text-secondary);\n  transition: color 0.2s ease;\n}\n\n.select-container:hover::after {\n  color: var(--text-primary);\n}\n\n/* Forms */\nform {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 200px;\n  flex: 1;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n/* Input Fields */\ninput[type=\"text\"],\ninput[type=\"number\"],\nselect,\ntextarea {\n  padding: 0.875rem 1rem;\n  border: 2px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  background: var(--surface-color);\n  color: var(--text-primary);\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"number\"]:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\ninput[type=\"text\"]::placeholder,\ninput[type=\"number\"]::placeholder,\ntextarea::placeholder {\n  color: var(--text-muted);\n}\n\ninput.form-input-reduced {\n  width: 14rem;\n  flex-grow: 0;\n}\n\n/* Buttons */\nbutton,\n.btn {\n  padding: 0.875rem 1.75rem;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n  letter-spacing: 0.3px;\n}\n\nbutton:hover,\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\nbutton:active,\n.btn:active {\n  transform: translateY(0);\n}\n\nbutton[type=\"submit\"],\nbutton.submit,\n.btn-success {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-dark) 100%);\n}\n\nbutton.danger,\n.btn-danger {\n  background: linear-gradient(135deg, var(--danger-color) 0%, var(--danger-dark) 100%);\n}\n\nbutton.icon-btn,\n.btn-icon {\n  padding: 0.625rem;\n  min-width: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n\nbutton.btn-lg {\n  padding: 1rem 2rem;\n  font-size: 1.125rem;\n}\n\n/* Tables */\ntable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\nth, td {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n}\n\nth {\n  background: linear-gradient(135deg, var(--nav-bg) 0%, #34495e 100%);\n  color: white;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n}\n\ntbody tr {\n  background: var(--surface-color);\n  transition: all 0.2s ease;\n}\n\ntbody tr:hover {\n  background: #f8f9fa;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\ntbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* Mobile Table Utilities */\n.mobile-hide {\n  display: table-cell;\n}\n\n.mobile-show {\n  display: none;\n}\n\n.mobile-stack {\n  display: block;\n}\n\n/* Live Page Layout */\n.live-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.live-container.live-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.live-league {\n  flex: 1;\n}\n\n/* Settings Button Group */\n.settings-button-group {\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n}\n\n.settings-buttons {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n/* League Display Styles */\n.next-up-section {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-left: 4px solid var(--primary-color);\n}\n\n.next-up-text {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  margin: 0 0 0.5rem 0;\n  font-weight: 600;\n}\n\n.progress-bar-container {\n  height: 6px;\n  width: 100%;\n  background-color: #dee2e6;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  transition: width 0.1s linear;\n  border-radius: 3px;\n}\n\n.league-header {\n  margin-bottom: 1rem;\n}\n\n/* Standings Table Styles */\n.standings-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 0 0.5rem;\n}\n\n.standings-header h3 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.league-name-badge {\n  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);\n  letter-spacing: 0.3px;\n}\n\n.standings-table-container {\n  background: var(--surface-color);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n  overflow-y: hidden;\n  margin: 1rem 0;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Subtle background tint using league color - uses Color tool */\n.standings-table-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--league-color-light, hsl(145, 63%, 95%));\n  opacity: 0.3;\n  pointer-events: none;\n  border-radius: 12px;\n}\n\n.standings-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n  position: relative;\n  z-index: 1;\n}\n\n.standings-table thead {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  color: rgb(60, 62, 85);\n}\n\n.standings-table th {\n  padding: 1rem 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  letter-spacing: 0.5px;\n  border: none;\n  position: relative;\n  cursor: help;\n  transition: background-color 0.2s ease;\n}\n\n.standings-table th:hover {\n  background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);\n}\n\n/* Custom Tooltip Styles */\n.standings-table th[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: -35px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  letter-spacing: 0.3px;\n  text-transform: none;\n}\n\n.standings-table th[title]:hover::before {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 8px solid rgba(0, 0, 0, 0.9);\n  z-index: 1001;\n}\n\n.position-header {\n  width: 50px;\n  text-align: center;\n}\n\n.team-header {\n  text-align: left;\n  min-width: 180px;\n}\n\n.stat-header {\n  width: 60px;\n  text-align: center;\n}\n\n.points-header {\n  width: 80px;\n  text-align: center;\n}\n\n.standings-row {\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.standings-row:nth-child(even) {\n  background-color: #fafbfc;\n}\n\n.standings-row:hover {\n  background-color: #e8f4fd;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.standings-row {\n  border-left: 4px solid var(--league-color-dark, #2ecc71);\n}\n\n.standings-table td {\n  padding: 1rem 0.75rem;\n  border: none;\n  vertical-align: middle;\n}\n\n.position-cell {\n  text-align: center;\n  font-weight: 600;\n}\n\n.position-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 0.9rem;\n  background: linear-gradient(135deg, #ecf0f1 0%, #bdc3c7 100%);\n  color: #2c3e50;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.position-number.first-place {\n  background: linear-gradient(135deg, var(--gold-light) 0%, var(--gold-dark) 100%);\n  color: #2c3e50;\n  font-weight: 700;\n  box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4);\n}\n\n.position-number.second-place {\n  background: linear-gradient(135deg, var(--silver-light) 0%, var(--silver-dark) 100%);\n  color: #2c3e50;\n  font-weight: 700;\n  box-shadow: 0 2px 6px rgba(192, 192, 192, 0.4);\n}\n\n.position-number.third-place {\n  background: linear-gradient(135deg, var(--bronze-light) 0%, var(--bronze-dark) 100%);\n  color: white;\n  font-weight: 700;\n  box-shadow: 0 2px 6px rgba(205, 127, 50, 0.4);\n}\n\n.team-cell {\n  text-align: left;\n}\n\n.team-name {\n  font-weight: 600;\n  font-size: 1rem;\n  color: #2c3e50;\n}\n\n.stat-cell {\n  text-align: center;\n  font-weight: 500;\n  color: #555;\n}\n\n.stat-cell.wins {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n.stat-cell.draws {\n  color: #f39c12;\n  font-weight: 600;\n}\n\n.stat-cell.losses {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.goal-difference.positive {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n.goal-difference.negative {\n  color: #e74c3c;\n  font-weight: 600;\n}\n\n.goal-difference.neutral {\n  color: #7f8c8d;\n}\n\n.points-cell {\n  text-align: center;\n}\n\n.points-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 32px;\n  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n  color: white;\n  border-radius: 16px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 0 8px;\n  box-shadow: 0 2px 4px rgba(52, 152, 219, 0.3);\n}\n\n/* Settings Icon */\n.pause-icon,\n.settings-icon {\n  margin-left: 0;\n}\n\n.settings-icon {\n  margin-left: auto;\n}\n\n/* League Row Styling */\n.league-row {\n  transition: all 0.2s ease;\n}\n\n.league-row:hover {\n  background-color: #e8f4fd;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  /* Navigation */\n  nav {\n    padding: 0.5rem 1rem;\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n\n  nav ul {\n    gap: 0.5rem;\n    justify-content: center;\n  }\n\n  nav a {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  .floating-logo {\n    height: 32px;\n    margin-bottom: 0.25rem;\n  }\n\n  .settings-icon a {\n    padding: 0.75rem;\n  }\n\n  /* Layout */\n  main {\n    padding: 2rem 0;\n  }\n\n  .container {\n    padding: 0 1rem;\n  }\n\n  .card {\n    padding: 1.5rem;\n    border-radius: 12px;\n  }\n\n  /* Typography */\n  h1 {\n    font-size: 2rem;\n  }\n\n  h2 {\n    font-size: 1.5rem;\n  }\n\n  h3 {\n    font-size: 1.25rem;\n  }\n\n  /* Forms */\n  form {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .form-group {\n    min-width: 100%;\n  }\n\n  /* Buttons */\n  button,\n  .btn {\n    padding: 0.75rem 1.25rem;\n    font-size: 0.9rem;\n  }\n\n  /* Tables */\n  table {\n    font-size: 0.9rem;\n  }\n\n  th,\n  td {\n    padding: 1rem 0.75rem;\n  }\n\n  /* Standings Table */\n  .standings-table {\n    font-size: 0.85rem;\n    min-width: 100%;\n  }\n\n  .standings-table th,\n  .standings-table td {\n    padding: 0.75rem 0.5rem;\n    white-space: nowrap;\n  }\n\n  .team-header {\n    min-width: 120px;\n  }\n\n  .stat-header {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .points-header {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .position-header {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .position-number {\n    width: 24px;\n    height: 24px;\n    font-size: 0.8rem;\n  }\n\n  .points-badge {\n    min-width: 32px;\n    height: 28px;\n    font-size: 0.85rem;\n  }\n\n  /* Ensure table scrolls horizontally on mobile */\n  .standings-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Dialog */\n  .dialog {\n    padding: 2rem;\n    max-width: 90%;\n  }\n\n  /* Mobile Table Utilities */\n  .mobile-hide {\n    display: none;\n  }\n\n  .mobile-show {\n    display: table-cell;\n  }\n\n  .mobile-stack {\n    display: block;\n    margin-bottom: 0.5rem;\n  }\n\n  /* Fixtures table mobile optimization */\n  .fixtures-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .fixtures-table input[type=\"number\"] {\n    width: 40px !important;\n    padding: 0.5rem 0.25rem;\n    text-align: center;\n    font-size: 0.875rem;\n  }\n\n  .fixtures-table .table-actions {\n    gap: 0.25rem;\n  }\n\n  .fixtures-table .table-actions button {\n    min-width: 40px;\n  }\n\n  /* Results table mobile optimization */\n  .results-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .results-table .table-actions {\n    gap: 0.25rem;\n  }\n\n  /* Live Page Layout */\n  .live-container {\n    flex-direction: column;\n    padding: 0.5rem;\n  }\n\n  .live-container.live-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .live-league {\n    width: 100%;\n    margin-bottom: 2rem;\n  }\n\n  .live-league:last-child {\n    margin-bottom: 0;\n  }\n\n  /* Next Up Section - Full width on mobile */\n  .next-up-section {\n    padding: 0.75rem;\n  }\n\n  .next-up-text {\n    font-size: 0.9rem;\n  }\n\n  .progress-bar-container {\n    height: 5px;\n  }\n\n  /* Settings Button Group */\n  .settings-button-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .settings-buttons {\n    width: 100%;\n  }\n\n  .settings-buttons button {\n    flex: 1;\n  }\n}\n\n/* Small Mobile - 480px and below */\n@media (max-width: 480px) {\n  /* Navigation */\n  nav {\n    padding: 0.5rem;\n    gap: 0.5rem;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  nav ul {\n    width: 100%;\n    justify-content: space-around;\n    gap: 0.25rem;\n  }\n\n  nav a {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.8rem;\n    min-height: 44px;\n    min-width: 44px;\n    text-align: center;\n  }\n\n  .floating-logo {\n    height: 28px;\n    margin-bottom: 0.5rem;\n  }\n\n  .settings-icon {\n    margin-left: 0;\n  }\n\n  .settings-icon a {\n    padding: 0.625rem;\n  }\n\n  /* Layout */\n  main {\n    padding: 1.5rem 0;\n  }\n\n  .container {\n    padding: 0 0.75rem;\n  }\n\n  .card {\n    padding: 1rem;\n    border-radius: 8px;\n  }\n\n  /* Typography */\n  h1 {\n    font-size: 1.75rem;\n  }\n\n  h2 {\n    font-size: 1.25rem;\n  }\n\n  h3 {\n    font-size: 1.1rem;\n  }\n\n  /* Buttons */\n  button,\n  .btn {\n    padding: 0.625rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  /* Tables */\n  table {\n    font-size: 0.8rem;\n  }\n\n  th,\n  td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  /* Standings Table */\n  .standings-table {\n    font-size: 0.75rem;\n    min-width: 100%;\n  }\n\n  .standings-table th,\n  .standings-table td {\n    padding: 0.625rem 0.375rem;\n    white-space: nowrap;\n  }\n\n  .team-header {\n    min-width: 100px;\n  }\n\n  .stat-header {\n    width: 40px;\n    min-width: 40px;\n  }\n\n  .points-header {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .position-header {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .position-number {\n    width: 22px;\n    height: 22px;\n    font-size: 0.75rem;\n  }\n\n  .points-badge {\n    min-width: 28px;\n    height: 24px;\n    font-size: 0.75rem;\n    padding: 0 6px;\n  }\n\n  /* Dialog */\n  .dialog {\n    padding: 1.5rem;\n    max-width: 95%;\n  }\n\n  /* Fixtures table - more compact */\n  .fixtures-table input[type=\"number\"] {\n    width: 35px !important;\n    padding: 0.375rem 0.125rem;\n    font-size: 0.8rem;\n  }\n\n  .fixtures-table .table-actions {\n    flex-wrap: wrap;\n  }\n\n  .fixtures-table .table-actions button {\n    font-size: 0.75rem;\n    padding: 0.5rem;\n  }\n\n  /* Results table - more compact */\n  .results-table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.85rem;\n  }\n\n  .results-table .table-actions button {\n    padding: 0.5rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
